import { render, staticRenderFns } from "./SocialSgLinks.vue?vue&type=template&id=85606fe6"
import script from "./SocialSgLinks.vue?vue&type=script&lang=ts"
export * from "./SocialSgLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports